<template>
  <div class="image-up-load">
    <el-upload ref="upload" :limit="limit" accept="image/png, image/jpg, image/jpeg" :auto-upload="false" action=""
               list-type="picture"
               :on-exceed="handleExceed" multiple>
      <el-button type="primary" icon="el-icon-upload">{{ butText }}</el-button>
      <div slot="tip" class="el-upload__tip">只能上传图片，且不超过5MB</div>
    </el-upload>
  </div>
</template>
<script>

export default {
  name: 'ImageUpLoad',
  props: {
    limit: {
      type: Number,
      default: 5
    },
    butText: {
      type: String,
      default: ''
    }
  },
  data() {
    return {};
  },
  methods: {
    // 文件超出数量限制回调
    handleExceed() {
      this.$message.error(`图片数量不能超过 ${this.limit} 张!`);
    },
  }
};

</script>
<style scoped lang="scss">

</style>
